import { render, staticRenderFns } from "./Crm.vue?vue&type=template&id=41d9bae0"
import script from "./Crm.vue?vue&type=script&lang=ts"
export * from "./Crm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports